import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Error Interceptor - Handles HTTP errors globally.
 * Manages error responses, redirects on 401/403, and provides error notifications.
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error) => {
      // Handle different HTTP error codes
      switch (error.status) {
        case 401:
          // Unauthorized - redirect to login
          router.navigate(['/login']);
          break;

        case 403:
          // Forbidden - redirect to home or access denied page
          router.navigate(['/home']);
          break;

        case 500:
        case 502:
        case 503:
        case 504:
          // Server errors
          console.error('Server error:', error);
          break;

        default:
          // Other errors
          console.error('HTTP error:', error);
      }

      // TODO: Add notification service to show error messages to user
      // Example: inject(NotificationService).error(error.message || 'An error occurred');

      return throwError(() => error);
    }),
  );
};
